<div class="ocorrencias">
    <div class="ocorrencias-em-recurso" *ngIf="porTipoOcorrencia(ocorrencias, 'ATIVO').length> 0">
        <h4>Ocorrencias em recurso <span class="badge">{{porTipoOcorrencia(ocorrencias, 'ATIVO').length}}</span></h4>
        <ng-template ngFor let-ocorrencia [ngForOf]="porTipoOcorrencia(ocorrencias, 'ATIVO')" let-i="index">
            <div class="box">
                <div class="box-header">{{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}} |
                    {{ocorrencia.situacaoAnalise}}</div>
                <div class="box-body">
                    <div class="action">
                        <a [routerLink]="['/recurso','ocorrencia', ocorrencia.id]"
                            (click)="preencherRecurso(ocorrencia)"><em class="pi pi-file"
                                style="font-size: 1.2rem"></em> Preencher dados de recurso</a>
                    </div>
                    <div class="content">
                        <ul>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Etapa</p> <span
                                    class="value">{{ocorrencia.situacaoAnalise}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Id da
                                    Ocorrência
                                </p> <span class="value">{{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Tipo de recurso
                                    esperado</p>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'E'">
                                    <span class="value">POR ETAPA</span>
                                </ng-template>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'P'">
                                    <span class="value">POR PARECER </span>
                                </ng-template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="ocorrencias-encaminhadas" *ngIf="porTipoOcorrencia(ocorrencias, 'ENVIADO').length> 0">
        <h4>Ocorrências encaminhadas para análise <span class="badge">{{porTipoOcorrencia(ocorrencias,
                'ENVIADO').length}}</span></h4>
        <ng-template ngFor let-ocorrencia [ngForOf]="porTipoOcorrencia(ocorrencias, 'ENVIADO')" let-i="index">
            <div class="box">
                <div class="box-header">Ocorrência: {{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}} |
                    {{ocorrencia.situacaoAnalise}}</div>
                <div class="box-body">
                    {{listarDocumentos(ocorrencia)}}
                    <div class="action">
                        <a class="btn-pareceres" (click)="documentosEmitidos(ocorrencia)"><em class="pi pi-tag"></em>
                            Parecer da Análise</a>

                        <ng-template ngFor let-item [ngForOf]="ocorrencia.documentos" let-i="index">
                            <a href="{{item._links.self.href}}" target="blank"><em class="pi pi-download"></em>
                                <ng-template [ngIf]="item.tpArquivo == 'J'"><span> Justificativa</span></ng-template>
                                <ng-template [ngIf]="item.tpArquivo == 'P'"><span> Parecer</span></ng-template>
                                <ng-template [ngIf]="item.tpArquivo == 'A'"><span> Anexo</span></ng-template>
                                {{item.nmArquivo}}</a>
                        </ng-template>


                    </div>
                    <div class="content">
                        <ul>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Etapa</p> <span
                                    class="value">{{ocorrencia.situacaoAnalise}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Id da
                                    Ocorrência
                                </p> <span class="value">{{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Tipo de recurso
                                    esperado</p>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'E'">
                                    <span class="value">POR ETAPA</span>
                                </ng-template>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'P'">
                                    <span class="value">POR PARECER </span>
                                </ng-template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="ocorrencias-expiradas" *ngIf="porTipoOcorrencia(ocorrencias, 'EXPIRADO').length> 0">
        <h4>Ocorrências com recursos expirados <span class="badge">{{porTipoOcorrencia(ocorrencias, 'EXPIRADO').length}}</span></h4>
        <ng-template ngFor let-ocorrencia [ngForOf]="porTipoOcorrencia(ocorrencias, 'EXPIRADO')" let-i="index">
            <div class="box">
                <div class="box-header">Ocorrencia {{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}} |
                    {{ocorrencia.situacaoAnalise}}</div>
                <div class="box-body">
                    <div class="action">
                        <a class="btn-pareceres" (click)="documentosEmitidos(ocorrencia)"><em class="pi pi-tag"></em>
                            Parecer da Análise</a>

                    </div>

                    <div class="content">
                        <ul>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Etapa</p> <span
                                    class="value">{{ocorrencia.situacaoAnalise}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Id da
                                    Ocorrência
                                </p> <span class="value">{{ocorrencia.reconsideracaoOcorrencia.idOcorrencia}}</span>
                            </li>
                            <li>
                                <p class="box-label"><em class="pi pi-book"></em> Tipo de recurso
                                    esperado</p>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'E'">
                                    <span class="value">POR ETAPA</span>
                                </ng-template>
                                <ng-template [ngIf]="ocorrencia.tipoRecursoEsperado == 'P'">
                                    <span class="value">POR PARECER </span>
                                </ng-template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <ng-template [ngIf]="pareceresEmitidos.length > 0">
        <div class="pareceres-emitidos">
            <div class="pareceres-emitidos-content">
                <div class="header">Pareceres Emitidos Na Análise <a
                        (click)="fecharModalPareceresEmitidos()" class="close"><em class="pi pi-times-circle"></em></a>
                </div>
                <div class="arquivos" *ngFor="let parecer of pareceresEmitidos">
                    <span class="header-fase"> {{parecer.nomeEtapa}}</span>
                    <a class="btn btn-default" (click)="downloadDocumentoParecer(parecer)"  target="_blank"><em class="pi pi-download"></em>
                        {{parecer.nmArquivo}} </a>
                </div>
            </div>
        </div>
    </ng-template>
</div>